import {
  Button,
  Dialog,
  List,
  ListItem,
  Menu,
  MenuItem,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import { createSelector } from "reselect";
import { IApplicationState } from "../../redux/root-reducer";
import { getUserInfo, updateDomainSettings } from "../common.actions";
import { actionCreator } from "../common.reducer";
import {
  IDomain,
  ILandLordInfo,
  isLandlordTypeGuard,
  ITenantInfo,
} from "../models/userInfo";
import styles from "./UserInfo.module.scss";

export interface IUserInfoState {
  userInfo: ILandLordInfo | ITenantInfo;
  selectedDomain: IDomain | null;
}
const getCommonState = createSelector(
  (state: IApplicationState) => state.common,
  (commonItems) => ({
    userInfo: commonItems.currentUserInfo,
    selectedDomain: commonItems.selectedDomain,
  })
);

function SimpleDialog(props: any) {
  const { onClose, open } = props;
  const { userInfo } = useSelector(getCommonState);
  const handleListItemClick = (value: IDomain) => {
    onClose(value);
  };
  const { t } = useTranslation();

  return (
    <Dialog aria-labelledby="simple-dialog-title" open={open}>
      <p className={styles.dialogTitle}>{t("Select domain:")}</p>
      <List>
        {userInfo.Domains.map((Domain) => (
          <ListItem
            key={`domain-${Domain.Code}`}
            button
            onClick={() => handleListItemClick(Domain)}
          >
            <p className={styles.listText}>{Domain.Name}</p>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}
const UserInfo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch("/:domain");
  const { userInfo, selectedDomain } = useSelector(getCommonState);
  const [open, setOpen] = useState(true);
  const [selectedValue, setSelectedValue] = useState<IDomain>(
    userInfo.Domains[0]
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = (value: IDomain) => {
    setOpen(false);
    setSelectedValue(value);
    dispatch(actionCreator.setSelectedDomain(value));
    history.push("/");
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSelectedDomain = async (selectedDomainInput: IDomain) => {
    setAnchorEl(null);
    if (selectedDomain?.Code === selectedDomainInput.Code) return;
    setSelectedValue(selectedDomainInput);
    dispatch(actionCreator.setSelectedDomain(selectedDomainInput));
    dispatch(updateDomainSettings(selectedDomainInput));
    history.push("/");
  };

  React.useEffect(() => {
    //@ts-ignore
    dispatch(getUserInfo(match?.params?.domain, history));
  }, []);

  return (
    <div>
      {userInfo.Domains.length > 1 ? (
        <div>
          {selectedValue === undefined && selectedDomain === null && (
            <div>
              <SimpleDialog
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
              />
            </div>
          )}
          <div className={styles.containerGrey}>
            <h4 className={styles.text}>
              {isLandlordTypeGuard(userInfo)
                ? `${selectedDomain?.Name} - ${userInfo.GivenName} ${userInfo.SurName}`
                : selectedDomain?.Name}
            </h4>
            <div className={styles.selectTimeContainer}>
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
              >
                <ArrowDropDownIcon className={styles.arrowIcon} />
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {userInfo.Domains.map((Domain) => (
                  <MenuItem
                    key={`domain-${Domain.Code}`}
                    onClick={() => handleSelectedDomain(Domain)}
                  >
                    {Domain.Name}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </div>
        </div>
      ) : (
        <h4 className={styles.containerGrey}>
          {isLandlordTypeGuard(userInfo)
            ? `${selectedDomain?.Name} - ${userInfo.GivenName} ${userInfo.SurName}`
            : selectedDomain?.Name}
        </h4>
      )}
    </div>
  );
};

export default UserInfo;
